export default __webpack_public_path__ + "static/media/Ring of the Fallen Empire.aadbf99f.jpg";